module.exports = __webpack_public_path__ + "static/media/signage-indoor-img82.4d3a6a2a.jpg";